import Splide from "@splidejs/splide";

const homepageTestimonials = new Splide( '.testimonials-slider', {
    perPage: 1,
    perMove: 1,
    arrows: true,
    pagination: true,
    autoplay: true,
    rewind: true,
} );

homepageTestimonials.mount();
